import { Breadcrumbs } from './Breadcrumbs';
import type { IPageBreadcrumbsProps } from './IPageBreadcrumbsProps';
import { usePageCrumbs } from './usePageCrumbs';

/**
 * Крихти поточної сторінки «Робочий простір › Група › Модуль (› Таблиця › Запис)» за маршрутом — для слоту крихт шапки сторінки модуля
 * (PageFrame → PageCrumbs) і для системних сторінок (Головна, Вхідні, Пошук, Усі модулі) в оболонці; `page` — підпис розділу системного
 * модуля замість типового («Каталог модулів» на рівні «Глобально»).
 */
export function PageBreadcrumbs({ page }: IPageBreadcrumbsProps = {}) {
  return <Breadcrumbs items={usePageCrumbs(undefined, page)} />;
}
